import { Type } from "@angular/core";
import { Installation } from "src/app/backend/models/installation";
import { IntegrationState } from "src/app/integrations/integration-state";

export interface IntegrationLayout {
  actions?: IntegrationLayoutAction[];
  buttons?: IntegrationLayoutAction<any>[];
  menu?: IntegrationLayoutMenu[];
  dataGridColumns?: IntegrationLayoutDataGridColumn[];
  warnings?: IntegrationLayoutWarning[];
  properties?: IntegrationLayoutProperty[];
  tabs?: IntegrationLayoutTab[];
}

export enum IntegrationDropPoints {
  WAREHOUSE_SELLINGS_MASTER = "warehouse-selling-master",
  WAREHOUSE_GOODS_MASTER = "warehouse-goods-master",
  WORK_ORDERS_MASTER = "work-orders-master",
  WORK_ORDER_DETAIL = "work-order-detail",
  MENU_WAREHOUSE = "menu-warehouse",
  RATETABLE_DETAIL_MEDICAL_SERVICES = "ratetable-detail-medical-services",
  PATIENT_DETAIL = "patient-detail",
  PRESCRIPTION_MASTER = "prescription-master",
  PRESCRIPTION_DETAIL = "prescription-detail",
  PRESCRIPTION_EDIT = "prescription-edit"
}

type IntegrationLayoutActionBaseParams = { installation: Installation };

export type IntegrationLayoutFeature =
  | IntegrationLayoutAction
  | IntegrationLayoutDataGridColumn
  | IntegrationLayoutMenu
  | IntegrationLayoutWarning
  | IntegrationLayoutProperty
  | IntegrationLayoutTab;

export interface IntegrationLayoutAction<
  T extends IntegrationLayoutActionBaseParams =
    IntegrationLayoutActionBaseParams
> {
  installation?: Installation;
  integrationName: string;
  dropPoints: IntegrationDropPoints[];
  do: ({ installation }: T) => void | Promise<void>;
  render: (state: IntegrationState) => IntegrationLayoutActionRendered;

  skipConnectionExistenceCheck?: boolean;
}

export interface IntegrationLayoutActionRendered {
  label: string;
  icon: string;
  disabled: boolean;
}

export interface IntegrationLayoutMenu {
  installation?: Installation;
  dropPoints: IntegrationDropPoints[];
  label: string;
  icon: string;
  path: string;
}

export interface IntegrationLayoutDataGridColumn<T = any> {
  installation?: Installation;
  integrationName: string;
  dropPoints: IntegrationDropPoints[];

  index?: number;
  name: string;
  dataField: string;
  width?: number;
  cssClass?: string;
  caption: () => string;
  cellTemplate: (cellElement: HTMLElement, data: T) => void;
}

export interface IntegrationLayoutWarning<T = any> {
  installation?: Installation;
  integrationName: string;
  dropPoints: IntegrationDropPoints[];

  message: (entity: T) => {
    message: string;
    icon: string | undefined;
    link: string | undefined;
    linkText: string | undefined;
  } | null;
}

export interface IntegrationLayoutProperty<T = any> {
  installation?: Installation;
  integrationName: string;
  dropPoints: IntegrationDropPoints[];

  label: () => string;
  icon: () => string | undefined;
  dataType: () => "text" | "number";
  value: (entity: T) => string | number | null;
}

export interface IntegrationLayoutTab {
  installation?: Installation;
  dropPoints: IntegrationDropPoints[];
  title: () => string;
  icon: string;
  component: Type<any>;
}
